import React, { useEffect } from "react";
import { RegistrationForm } from "./RegistrationForm";
import Header from "../../../components/Header";
import "./index.scss";
import { codeSnippetFunc } from "../../../utils/commonFunctions";


const RegistartionComponent = (props) => {

  useEffect(() => {
    document.title = 'Register for Guardian Anytime | Guardian';
    codeSnippetFunc('Page Viewed', 'Registration screen');
  }, []);

  return (
    <div className="registration-wrapper">
      <Header />
      <div className=" welcomeExperience__container" role="main">
        <div className="welcomeExperience__body">
          <div className="welcomeExperience__dob">
            <h1 class="welcomeExperience__bodyHeadingRegistration heading">
              Register for Guardian Anytime.
            </h1>
            <div className="welcomeExperience__topContent">
              Guardian Anytime lets you manage benefits, claims, and cards,
              wherever you are. Create a password to register.
            </div>
            <RegistrationForm {...props} />

          </div>
        </div>
      </div>
    </div>
  );
};

export const Registartion = RegistartionComponent;